import * as React from 'react';
import { FixMeLater } from '../../../utils';
import { Typography, TypographyBaseProps } from '../Typography';
import { useComponentDefaultProps, TypographyPriceSize } from '../../../theming';

export interface PriceProps extends TypographyBaseProps {
    size?: TypographyPriceSize;
}

const defaultProps: Partial<PriceProps> = {
    color: 'text.price',
    size: 'm',
    component: 'span',
};

export const Price: React.ForwardRefExoticComponent<PriceProps & React.RefAttributes<HTMLElement>> = React.forwardRef(
    function Price(props: PriceProps, ref: React.ForwardedRef<FixMeLater>): React.JSX.Element {
        const { size = 'm', color, ...other } = useComponentDefaultProps('Price', defaultProps, props);

        return <Typography ref={ref} family="price" size={size} color={color} {...other} />;
    }
);
